import { IFleetInitialState } from "./types";

const initialState: IFleetInitialState = {
  selectedDrone: null,
};

export default initialState;